import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { Producto } from 'src/app/models/generic/Producto';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { ProductosResumen } from '../../models/generic/ProductosResumen';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { Listas } from 'src/app/models/generic/Listas';
import { TopAfiliadosResumen } from '../../models/generic/TopAfiliadosResumen';

@Component({
  selector: 'globalafiliados',
  templateUrl: './globalafiliados.component.html',
  styleUrls: ['./globalafiliados.component.scss']
})
export class GlobalafiliadosComponent implements OnInit{
  
  mostrarCargando: boolean = true;
  porcentajeTotalMesAnterior: number = 0;
  porcentajeNuevoMesAnterior: number = 0;
  porcentajeInactivosMesAnterior: number = 0;
  descripcionTotalMesAnterior: string = '';
  descripcionNuevoMesAnterior: string = '';
  descripcionInactivosMesAnterior: string = '';

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    if (this.autenticacionService.EstaAutenticado()) {
      this.cargarResumen();

      this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
        if (cambiarResumen) {
          this.cargarResumen();
        }
      });
    }
  }

  cargarResumen(mes: number = 0) {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('mes').setValue(mes);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.productosService.CargarTopAfiliadosResumen(parametrosConsulta.value).subscribe((resp: TopAfiliadosResumen[]) => {
      this.productosService.ListaTopAfiliadosResumen = resp;

      if (this.utilitariosService.VerificarContieneDatosLista(this.productosService.ListaTopAfiliadosResumen)) {
        this.porcentajeTotalMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadTotalPorcentajeFrenteAlAnterior;
        this.porcentajeNuevoMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadNuevosPorcentajeFrenteAlAnterior;
        this.porcentajeInactivosMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadInactivosPorcentajeFrenteAlAnterior;

        this.descripcionTotalMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadTotalDescripcion;
        this.descripcionNuevoMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadNuevosDescripcion;
        this.descripcionInactivosMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadInactivosDescripcion;
      }

      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  ColorPorcentajeTotalMesAnterior(): string {
    if (this.porcentajeTotalMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
  ColorPorcentajeNuevoMesAnterior(): string {
    if (this.porcentajeNuevoMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
  ColorPorcentajeInactivosMesAnterior(): string {
    if (this.porcentajeInactivosMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
}
